import datapoints from '../../../datapoints';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import {
    updateUserPreferenceForCloudFile,
    updateUserPreferenceForGroupsFile,
} from '../../../services/updateFilePickerConfiguration';

export const setPreferredActionForCloudFile = createLegacyActionWithDatapoint(
    'setPreferredActionForCloudFile',
    datapoints.AFPSetUserPreferredAction
)(function setPreferredActionForCloudFile(configuration: OwaUserConfiguration, action: number) {
    configuration.ViewStateConfiguration.AttachOrShareCloudFiles = action;
    updateUserPreferenceForCloudFile(configuration);
});

export const setPreferredActionForGroupsFile = createLegacyActionWithDatapoint(
    'setPreferredActionForGroupFile',
    datapoints.AFPSetUserPreferredActionGroups
)(function setPreferredActionForGroupsFile(configuration: OwaUserConfiguration, action: number) {
    configuration.ViewStateConfiguration.AttachOrShareGroupsFiles = action;
    updateUserPreferenceForGroupsFile(configuration);
});
